'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { PageNavigation } from '@/components/client';
import { CartContent } from './_components/CartContent';
const CartPage = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <main className={cn("bg-Gray-white [&_button[data-state=checked]:not(:disabled)]:bg-O-400", "mobile-tablet:pb-160 mobile-tablet:pt-0")}><PageNavigation title={"\uC6F0\uB9C8\uCF19 \uC7A5\uBC14\uAD6C\uB2C8"} hideHomeButton={true} /><CartContent /></main>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default CartPage;